module.exports = __webpack_public_path__ + "static/media/outbound_icon.48c1ca33.svg";